import { formatDateTime } from 'utils/helpers';

export const WP_SITE_CONNECTION_REPORT = 'WP Site Connections';

export const WP_SITE_CONNECTIONS_REPORT_MESSAGE =
  `This report shows all active repairers that are currently connected to this work provider. 
  The data shown is based on the Data Access Profile assigned to your account. As a result, you may not see all repairers if your profile does not have permission to view them.`;

export const WP_SITE_CONNECTION_REPORT_GRID_TITLE = 'wpSiteConnectionsReport';

export const columns = [
  { name: 'repairerGroup', title: 'Group' },
  { name: 'siteCode', title: 'Site Code' },
  { name: 'capsCodes', title: 'CAPS Codes' },
  { name: 'name', title: 'Name' },
  { name: 'address', title: 'Address' },
  { name: 'postcode', title: 'Postcode' },
  { name: 'systemType', title: 'System Type' },
  { name: 'connectionDetails', title: 'Connection Details' },
];

export const reportHeaderTagLine = `Report produced on ${formatDateTime(new Date())}`;
